import { render } from "./CustomDataFile.vue?vue&type=template&id=3322c883&scoped=true"
import script from "./CustomDataFile.vue?vue&type=script&lang=ts"
export * from "./CustomDataFile.vue?vue&type=script&lang=ts"

import "./CustomDataFile.vue?vue&type=style&index=0&id=3322c883&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-3322c883"

export default script